import React from 'react';

// Shared themed shell for the public legal pages (Terms, Privacy). Matches the
// purple site theme used across About/Contact.
const PURPLE_GRADIENT = 'linear-gradient(145deg,#7c3aed,#5b21b6)';

export default function LegalPage({ title, updated, intro, sections = [] }) {
    return (
        <div className="container-fluid py-5" style={{ background: '#f5f3ff', minHeight: '100vh' }}>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-9">
                        <div className="card shadow-sm" style={{ border: '1px solid #ede9fe', borderRadius: '0.9rem', overflow: 'hidden' }}>
                            <div style={{ background: PURPLE_GRADIENT, color: '#fff', padding: '2rem 1.5rem', textAlign: 'center' }}>
                                <h1 className="fs-2 fw-bold mb-1">{title}</h1>
                                {updated && (
                                    <p className="mb-0" style={{ opacity: 0.9, fontSize: '0.9rem' }}>Last updated: {updated}</p>
                                )}
                            </div>
                            <div className="card-body p-4 p-md-5">
                                {intro && <p className="text-secondary mb-4">{intro}</p>}
                                {sections.map((s, i) => (
                                    <div key={i} className="mb-4">
                                        <h2 className="fs-5" style={{ color: '#5b21b6', fontWeight: 700 }}>{s.heading}</h2>
                                        <p className="text-secondary mb-0" style={{ whiteSpace: 'pre-line' }}>{s.body}</p>
                                    </div>
                                ))}
                                <hr className="my-4" style={{ borderColor: '#ddd6fe', opacity: 1 }} />
                                <p className="text-muted small mb-0">
                                    Questions? Contact us at{' '}
                                    <a href="mailto:support@kobraprep.com" style={{ color: '#7c3aed' }}>support@kobraprep.com</a>.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
